module.exports = __webpack_public_path__ + "images/979445183da2bfaa90d6495a714e41d5-bg.jpg";